/**
 * 公共变量、函数
 */


/**
 * 
 * @returns mobile pc
 */
 export const _isMobile = () => {
    let flag, isMobile
    flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag === null) {
      isMobile = false;
    }else {
        isMobile = true;
    }
    return isMobile;
}





// WEBPACK FOOTER //
// ./src/common/util.js